import CloseIcon from '@mui/icons-material/Close';
import PauseCircleOutlineOutlinedIcon from '@mui/icons-material/PauseCircleOutlineOutlined';
import PlayCircleOutlinedIcon from '@mui/icons-material/PlayCircleOutlined';
import QrCodeIcon from '@mui/icons-material/QrCode';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Tooltip } from '@mui/material';

import '../styles/hover-menu.css';

interface Props {
    onCloseClick: () => void;
    onPauseClick?: () => void;
    onPlayClick?: () => void;
    onShowPlayerLink?: () => void;
    onOpenAdminOverview?: () => void;
    isPaused?: boolean;
}

export const HoverMenu = (props: Props) => {
    const iconStyleAdjust: React.CSSProperties = {
        marginTop: '8px'
    };

    return (
        <div className="quiz-hover-menu">
            <div className="hover-menu-indicator" onClick={props.onCloseClick}>
                <ArrowDropDownIcon fontSize="large" sx={iconStyleAdjust} />
            </div>
            {props.onCloseClick && (
                <div className="hover-menu-icon close" onClick={props.onCloseClick}>
                    <Tooltip title="Exit">
                        <CloseIcon fontSize="large" sx={iconStyleAdjust} />
                    </Tooltip>
                </div>
            )}
            {props.onPauseClick && props.onPlayClick && (
                <>
                    {!props.isPaused && (
                        <div className="hover-menu-icon pause-resume" onClick={props.onPauseClick}>
                            <Tooltip title="Pause">
                                <PauseCircleOutlineOutlinedIcon fontSize="large" sx={iconStyleAdjust} />
                            </Tooltip>
                        </div>
                    )}
                    {props.isPaused && (
                        <div className="hover-menu-icon pause-resume" onClick={props.onPlayClick}>
                            <Tooltip title="Resume">
                                <PlayCircleOutlinedIcon fontSize="large" sx={iconStyleAdjust} />
                            </Tooltip>
                        </div>
                    )}
                </>
            )}
            {props.onShowPlayerLink && (
                <div className="hover-menu-icon qr-code" onClick={props.onShowPlayerLink}>
                    <Tooltip title="Show Player Link">
                        <QrCodeIcon fontSize="large" sx={iconStyleAdjust} />
                    </Tooltip>
                </div>
            )}
            {props.onOpenAdminOverview && (
                <div className="hover-menu-icon admin-overview" onClick={props.onOpenAdminOverview}>
                    <Tooltip title="Open Admin Overview">
                        <AdminPanelSettingsOutlinedIcon fontSize="large" sx={iconStyleAdjust} />
                    </Tooltip>
                </div>
            )}
        </div>
    );
};
